<script>
export default {
  name: "NewRowForm",
  data() {
    return {
      newRowDialog: false,
      selectedTable: null,
      tableOptions: [
        {label:'Services Sales', id: 'serviceSales', type: false, price: true},
        {label:'Services Rendered', id: 'servicesRendered', type: true, price: false},
        {label:'Smog Sales', id: 'smogSales', type: false, price: true}],
      typeField: '',
      priceField: 0.00,
    }
  },
  computed: {
    fullSelectedTable() {
      return this.tableOptions.find(option => option.id === this.selectedTable);
    },
    showType() {
      if (!this.fullSelectedTable) return false;
      return this.fullSelectedTable.type
    },
    showPrice() {
      if (!this.fullSelectedTable) return false;
      return this.fullSelectedTable.price
    },
  },
  methods: {
    openDialog() {
      this.newRowDialog = true;
    },
    hideDialog() {
      this.newRowDialog = false;
    },
    saveRow() {
      this.$emit('add-row', this.selectedTable, this.typeField, this.priceField);
      this.hideDialog();
      this.selectedTable = null;
      this.typeField = '';
      this.priceField = 0.00;
    },
  },
  watch: {
    selectedTable() {
      if (this.selectedTable === 'serviceSalesTally') {
        this.typeField = 'service';
      }
      if (this.selectedTable === 'smogSalesTally') {
        this.typeField = 'smog';
      }
    }
  }
}
</script>

<template>
  <Dialog v-model:visible="newRowDialog" :style="{ width: '450px' }" header="New Row Details" :modal="true">
    <label for="table-input" class="mb-1 mt-3">Select Table to Modify</label>
    <Select id="table-input" class="w-full" v-model="selectedTable" :options="tableOptions" optionValue="id" optionLabel="label"></Select>
    <div class="mt-3" v-if="showType">
      <label for="type-input" class="mb-1">Type</label>
      <InputText id="type-input" v-model="typeField" class="w-full" placeholder="Type" />
    </div>
    <div class="mt-3" v-if="showPrice">
      <label for="price-input" class="mb-1">Price</label>
      <InputNumber id="price-input" mode="currency" currency="USD" locale="en-US" v-model="priceField" class="w-full" />
    </div>
    <template #footer>
      <Button label="Cancel" icon="pi pi-times" text @click="hideDialog" />
      <Button label="Save" icon="pi pi-check" @click="saveRow" />
    </template>
  </Dialog>
  <Button @click="openDialog" severity="secondary" size="small">New Row</Button>
</template>

<style scoped>

</style>